
import { dataType } from "./stateType";
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import { Router, useRoute, useRouter } from "vue-router";
import { dateFormat, directUploadFile, previewImage } from "@/utils/util";
import { getFileToken } from "../../../../api/user";
import {
  saveFarmingRecord,
  getFarmingTypeData,
  getFarmingData,
  updateFarmingRecord,
  getLandFilterData,
} from "../../../../api/farmer";
import { Toast } from "vant";
import PreviewVideo from "@/components/previewVideo/previewVideo.vue";
function stateData() {
  return {
    farmingTypeId: "",
    farmingTypeName: "",
    farmingName: "",
    date: "",
    area: "",
    person: "",
    imageList: [],
    videoList: [],
    other: "",
    id: "",
    showDateDialog: false,
    videoUrl: "",
    currentDate: new Date(
      dateFormat().YYYY,
      Number(dateFormat().MM) - 1,
      Number(dateFormat().DD)
    ),
    maxDate: new Date(
      dateFormat().YYYY,
      Number(dateFormat().MM) - 1,
      Number(dateFormat().DD)
    ),
    minDate: new Date(1900, 0, 1),
    showVideos: false,
    typeList: [],
    showTypePop: false,
    defaultIndex: 0,
    isDisabled: false,
    sourceId: "",
    sourceLandList: [],
    selectedLandName: "",
    selectedLandId: "",
    showLandPop: false,
    optionId: "",
    landIndex: 0,
  };
}

export default defineComponent({
  components: {
    PreviewVideo,
  },
  setup() {
    const state = reactive<dataType>(stateData());
    const $route = useRoute();
    const $router = useRouter();
    const {
      onSubmit,
      dateConfirm,
      imageUploadAfter,
      afterUploadVideo,
      onConfirm,
      onClickType,
      onClickLand,
      onLandConfirm,
      onDeleteImg,
      onClickImgPoster,
      onDeleteVideo,
      onClickVideo,
    } = useEvent(state, $router);
    const { getFarmingList, getLandList } = useNetwork(state);
    onMounted(() => {
      Object.assign(state, stateData());
      state.farmingTypeId = $route.query.typeId as string;
      state.farmingTypeName = $route.query.typeName as string;
      state.farmingName = $route.query.name as string;
      if ($route.query.name) {
        state.isDisabled = true;
      }
      state.id = $route.query.id as string;
      state.sourceId = $route.query.sourceId as string;
      state.selectedLandName = $route.query.landId as string;
      state.optionId = $route.query.optionId as string;
      if (state.sourceId) {
        getLandList();
      }
      state.date =
        dateFormat().YYYY + "-" + dateFormat().MM + "-" + dateFormat().DD;
      getFarmingList();
    });
    return {
      ...toRefs(state),
      onSubmit,
      dateConfirm,
      onClickLand,
      onClickType,
      imageUploadAfter,
      onClickImgPoster,
      onConfirm,
      onLandConfirm,
      onDeleteVideo,
      onDeleteImg,
      afterUploadVideo,
      ...useValidate(state),
      onClickVideo,
    };
  },
});

const useValidate = (state: dataType) => {
  const imageValidate = () => {
    if (state.imageList.length == 0) {
      return "至少上传一张照片";
    }
    return "";
  };
  return {
    imageValidate,
  };
};

const useNetwork = (state: dataType, router?: Router) => {
  const getLandList = async () => {
    const result: any = await getLandFilterData({ sourceId: state.sourceId });
    if (result.data.code == 0) {
      // 备份一个text用于组件展示
      state.sourceLandList = result.data.data.map((item: any) => {
        item.text = item.code;
        return item;
      });
      // 获取弹出框默认选中的地块下标用于组件回填
      state.landIndex = state.sourceLandList.findIndex((item: any) => {
        return item.code == state.selectedLandName;
      });
      let tempList = state.sourceLandList.filter((item: any) => {
        return item.code == state.selectedLandName;
      });
      // 回填的数据优先展示 没有数据回填时 默认选中第一个
      if (tempList.length > 0) {
        state.selectedLandId = tempList[0].id;
        state.selectedLandName = tempList[0].code;
      } else if (state.sourceLandList[0]) {
        state.selectedLandId = state.sourceLandList[0].id;
        state.selectedLandName = state.sourceLandList[0].code;
      }
    }
  };
  const getFarmingList = async () => {
    const result: any = await getFarmingTypeData();
    if (result.data.code == 0) {
      const { getFarmingInfo } = useEvent(state);
      state.typeList = result.data.data.records.map((item: any) => {
        item.text = item.name;
        return item;
      });
      let tempList = result.data.data.records.filter((item: any) => {
        return item.id == state.farmingTypeId;
      });
      if (tempList.length > 0) {
        state.farmingTypeName = tempList[0].name;
        state.farmingTypeId = tempList[0].id;
      } else {
        state.farmingTypeName = state.typeList[0].name;
        state.farmingTypeId = state.typeList[0].id;
      }

      if (state.id) {
        getFarmingInfo(state.id);
      }
    }
  };

  const updateFarmingInfo = async (data: any) => {
    const result: any = await updateFarmingRecord(data);
    if (result.data.code == 0) {
      Toast("已修改");
      const timer = setTimeout(() => {
        router && router.back();
        clearTimeout(timer);
      });
    }
  };

  const saveFarmingInfo = async (data: any) => {
    const result: any = await saveFarmingRecord(data);
    if (result.data.code == 0) {
      Toast("已保存");
      const timer = setTimeout(() => {
        router && router.back();
        clearTimeout(timer);
      });
    }
  };

  return {
    saveFarmingInfo,
    getFarmingList,
    getLandList,
    updateFarmingInfo,
  };
};

const useEvent = (state: dataType, router?: Router) => {
  const onClickImgPoster = (item: any) => {
    previewImage(
      state.imageList.map((item: any) => item.poster),
      item.index
    );
  };
  const onDeleteVideo = (item: any) => {
    state.videoList.splice(item.index, 1);
  };
  const onClickVideo = (item: any) => {
    state.videoUrl = item.url;
    state.showVideos = true;
  };
  const onDeleteImg = (item: any) => {
    state.imageList.splice(item.index, 1);
  };
  const getFarmingInfo = async (id: string) => {
    const result: any = await getFarmingData({ id: id });
    if (result.data.code == 0) {
      const temp = result.data.data;
      state.farmingName = temp.farmingName;
      state.farmingTypeId = temp.farmingType;
      state.other = temp.remark;
      state.date = temp.workTime;
      state.area = temp.area;
      state.person = temp.artificial;
      state.optionId = temp.optionId;
      state.defaultIndex = state.typeList.findIndex((item: any) => {
        return item.id == temp.farmingType;
      });
      state.imageList = temp.images.map((item: any) => {
        item.poster = item.url;
        item.progress = 100;
        return item;
      });
      state.videoList = temp.videos.map((item: any) => {
        item.poster = item.coverImg;
        item.progress = 100;
        return item;
      });
    }
  };
  const onLandConfirm = (e: any) => {
    state.selectedLandId = e.id;
    state.selectedLandName = e.code;
    state.showLandPop = false;
  };
  const onConfirm = (e: any) => {
    state.farmingTypeId = e.id;
    state.farmingTypeName = e.name;
    state.showTypePop = false;
  };
  const onClickType = () => {
    if (!state.isDisabled) {
      state.showTypePop = true;
    }
  };
  const onClickLand = () => {
    if (!state.isDisabled) {
      state.showLandPop = true;
    }
  };
  const afterUploadVideo = async (e: any) => {
    const result: any = await getFileToken({
      bucket: "xfarmer",
      fileType: 1,
      type: 2,
      token: localStorage.getItem("token"),
    });
    if (result.data.code == 0) {
      directUploadFile(e, result.data, { userType: "2", fileType: "1" });
    }
  };

  const imageUploadAfter = async (e: any) => {
    if (Array.isArray(e)) {
      e.forEach(async (item) => {
        const result: any = await getFileToken({
          bucket: "xfarmer",
          fileType: 0,
          type: 2,
          token: localStorage.getItem("token"),
        });
        if (result.data.code == 0) {
          // 执行该函数后，获取数据请直接从双向绑定的数组中取值.
          directUploadFile(item, result.data);
        }
      });
    } else {
      const result: any = await getFileToken({
        bucket: "xfarmer",
        fileType: 0,
        type: 2,
        token: localStorage.getItem("token"),
      });
      if (result.data.code == 0) {
        directUploadFile(e, result.data);
      }
    }
  };
  const dateConfirm = (e: any) => {
    state.date =
      dateFormat(e).YYYY + "-" + dateFormat(e).MM + "-" + dateFormat(e).DD;
    state.showDateDialog = false;
  };
  const onSubmit = async (values: any) => {
    const { saveFarmingInfo, updateFarmingInfo } = useNetwork(state, router);
    const param: any = {
      area: state.area,
      farmingName: state.farmingName,
      farmingType: state.farmingTypeId,
      remark: state.other,
      artificial: state.person,
      workTime: state.date,
      optionId: !state.optionId ? "" : state.optionId,
      areaId: state.selectedLandId,
      imageIds: state.imageList.map((item: any) => item.id).join(","),
      videoIds: state.videoList.map((item: any) => item.id).join(","),
    };
    if (state.id) {
      param.id = state.id;
      updateFarmingInfo(param);
    } else {
      saveFarmingInfo(param);
    }
  };
  return {
    onSubmit,
    dateConfirm,
    imageUploadAfter,
    afterUploadVideo,
    onClickType,
    getFarmingInfo,
    onLandConfirm,
    onClickLand,
    onConfirm,
    onDeleteImg,
    onDeleteVideo,
    onClickImgPoster,
    onClickVideo,
  };
};
